<template>
  <DpplTooltip
    v-if="
      typeof atsTotalApplicants === 'number'
        && authData.isApplicationReportingEnabled
        && reqReportUrl"
    tooltip-placement="bottom-start"
    :tooltip-offset="0"
    max-width="300px"
    close-on-content-click
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <div
        class="total-applicants-activator"
        v-bind="$attrs"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        <ApplicantIcon class="mr-1" />
        <p class="p5">
          {{ formatNumber(atsTotalApplicants) }}
        </p>
      </div>
    </template>
    <template #tooltip-content>
      <div class="d-flex flex-column align-center justify-start">
        <p class="p5 font-weight-medium">
          Total Applicants on Requisition
        </p>
        <h4 class="mt-2">
          {{ formatNumber(atsTotalApplicants) }}
        </h4>
        <ReqProgressButton class="d-flex align-center justify-center" />
      </div>
    </template>
  </DpplTooltip>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import { useEditor } from '@/stores/editor/editor';
import { storeToRefs } from 'pinia';
import ReqProgressButton from '@/components/editor/ReqProgressButton.vue';
import { numberWithCommas } from '@/helpers/formatters';
import { useAppAuthData } from '@/stores/app/authData';
import ApplicantIcon from '@/assets/icon-applicant.svg?component';

defineOptions({ inheritAttrs: false });

const { atsTotalApplicants, reqReportUrl } = storeToRefs(useEditor());
const { authData } = storeToRefs(useAppAuthData());

const formatNumber = (value) => numberWithCommas(value);
</script>

<style scoped lang="less">
.total-applicants-activator {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
